export { default as PaymentMethodsTableTxaV2 } from './src/payment-methods-table-txa-v2';
export { default as PaymentMethodsTableV2 } from './src/payment-methods-table-v2';
